/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UiFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return UiFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<UiFeatureFlagsWithDefaults>): UiFeatureFlagsWithDefaults {
        let obj = Object.assign(new UiFeatureFlagsWithDefaults(), model);
        UiFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UiFeatureFlagsWithDefaults>): UiFeatureFlagsWithDefaults {
        if (!model) return null;
        return UiFeatureFlagsWithDefaults.newInstance(<UiFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UiFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.UiFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UiFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UiFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    ui_2601_f_infra_dashboard_open_issues_trend: boolean = true;

    /**
     * Flag's default value
     */
    ui_2601_f_infra_dashboard_by_resource_category: boolean = true;

    /**
     * Flag's default value
     */
    ui_2601_f_widget_filter_lazy_select: boolean = true;

    /**
     * Flag's default value
     */
    ui_2602_f_lazy_dropdown_select: boolean = true;

    /**
     * Flag's default value
     */
    ui_2602_f_dimension_creation_wizard: boolean = true;

    /**
     * Flag's default value
     */
    ui_2602_f_infra_dashboard_enable_workload_filter: boolean = true;

    /**
     * Flag's default value
     */
    ui_2602_f_widget_lazy_sa: boolean = true;

    /**
     * Flag's default value
     */
    ui_2602_f_t2_data_time_range_presets: boolean = true;

    /**
     * Flag's default value
     */
    ui_2603_f_ai_observability_119985: boolean = true;

    /**
     * Flag's default value
     */
    ui_2603_f_remediation_explorer: boolean = true;

    /**
     * Flag's default value
     */
    ui_2605_f_azure_recommendations_source: boolean = false;

}
